import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Stats from "../components/Stats";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import Coverage from "../components/Coverage";
import Partners from "../components/Partners";
import LeadForm from "../components/LeadForm";
import Footer from "../components/Footer";
import { CONTACT } from "../data/site";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Mobile Maintenance",
  description: "Nationwide mobile fleet maintenance, on-site repair and preventative maintenance. 24/7/365 across the country.",
  telephone: "+1-432-276-7729",
  email: CONTACT.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: "4041 S County Rd W",
    addressLocality: "Odessa",
    addressRegion: "TX",
    postalCode: "79766",
    addressCountry: "US",
  },
  areaServed: "United States",
  openingHours: "Mo-Su 00:00-24:00",
};

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Mobile Maintenance | Nationwide Mobile Fleet Maintenance & On-Site Repair";
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = JSON.stringify(jsonLd);
    s.id = "ld-json";
    document.getElementById("ld-json")?.remove();
    document.head.appendChild(s);
  }, []);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Services />
        <Manifesto />
        <Coverage />
        <Partners />
        <LeadForm />
      </main>
      <Footer />
    </>
  );
}
